import React from "react";
import { NewsData } from "../../data/data";
import PostFr from "./PostFr";


function PostsFr() {
	return (
		<>
			<div className="sm:flex w-full overflow-x-auto  scrollbar-hide space-x-4 px-3">
				{NewsData &&
					NewsData.map((data, id) => (
						<div key={id}>
							<PostFr title={data.title} image={data?.image} des={data?.des} />
						</div>
					))}
			</div>
		</>
	);
}

export default PostsFr;
